export class FostplusTableDataSettings {
	public Show:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.Show = data.Show;
	}

	public getJSON(){
		return {
			Show: this.Show
		};
	}
}